import * as React from "react";
import {connect} from "react-redux";
import Brand from "../../../../model/brand/Brand";
import {RootState} from "../../../../store/reducer/root/RootState";
import SelectComponent, {SelectComponentComponentProps, SelectComponentReduxProps} from "../../../ui/select/SelectComponent";

class SelectBrand extends SelectComponent<Brand> {
	matchFilter(element: Brand, filter: string): boolean {
		return element.name.toLowerCase().indexOf(filter.toLowerCase()) > -1;
	}

	elementToId(element: Brand): string {
		return element.id;
	}

	elementToString(element: Brand) {
		return element.name;
	}
}

function mapStateToProps(state: RootState) {
	return {
		items: state.brand.brands
	}
}

export default connect<SelectComponentReduxProps<Brand>, SelectComponentComponentProps<Brand>>(
	mapStateToProps)(SelectBrand)